import {
  SteamPaymentFormData,
  SteamPaymentItem,
  TransactionStatus,
  CurrencyRate,
  AmountRestrictions,
  SelectedCurrencyInfo,
  ShopCurrencies,
} from './types'
import { createStore } from 'effector'
import { changeShopCurrency, updateSteamPaymentForm } from './events'
import { routes } from '@/app/routing/router'
import { getCurrencyRatesFx, getPaymentInfoFx, getSubscriptionPricesFx, getTransactionStatusFx } from './effects'
import { languageToCurrency } from '@/widgets/topUpSteam/constants'
import { combine } from 'effector'
import { sample } from 'effector'
import { changeSubscriptionPaymentOption } from './events'
import { SubscriptionPaymentOptions, SubscriptionPriceType } from './types'

const initialItemState: SteamPaymentItem = {
  value: '',
  isError: false,
}

const initialState: SteamPaymentFormData = {
  country: initialItemState,
  login: initialItemState,
  amount: initialItemState,
  currency: {
    value: 'XTR',
    isError: false,
  },
  paymentMethod: {
    value: 'Telegram Stars',
    isError: false,
  },
  amount_usd: {
    value: '',
    isError: false,
  },
}

export const $transactionHistoryQuery = routes.transactionHistory.$query.map((query) => query.to || 'main')
export const $transactionStatus = createStore<TransactionStatus>('PENDING').on(
  getTransactionStatusFx.doneData,
  (_, data) => {
    return data
  }
)

export const $selectedCurrencyInfo = createStore<SelectedCurrencyInfo | null>(null)

export const $steamPaymentFormData = createStore<SteamPaymentFormData>(initialState).on(
  updateSteamPaymentForm,
  (_, data) => data
)
export const $currencyRates = createStore<CurrencyRate[] | null>(null).on(getCurrencyRatesFx.doneData, (_, data) => {
  return data
})
sample({
  source: combine({
    steamPaymentFormData: $steamPaymentFormData,
    rates: $currencyRates,
  }),
  clock: $steamPaymentFormData.updates.map((data) => data.country || data.amount),
  fn: ({ steamPaymentFormData, rates }) => {
    if (!steamPaymentFormData.country || !rates) return null

    const countryKey = steamPaymentFormData.country.value as keyof typeof languageToCurrency
    const currencyCode = languageToCurrency[countryKey]?.[0] || ''
    const currencySymbol = languageToCurrency[countryKey]?.[1] || ''

    const usdToCurrencyMultiplier =
      rates.find((rate) => rate.currency_code == currencyCode && rate.base_currency_code == 'USD')?.exchange_rate ?? 1

    const usdValue = Number(steamPaymentFormData.amount?.value) * 0.012 // todo: constant
    const currencyValue = usdValue * usdToCurrencyMultiplier

    return {
      countryKey,
      currencyCode,
      currencySymbol,
      usdToCurrencyMultiplier,
      usdValue,
      currencyValue: Number(currencyValue.toFixed(2)),
    }
  },
  target: $selectedCurrencyInfo,
})

export const $paymentInfo = createStore<AmountRestrictions | null>(null).on(getPaymentInfoFx.doneData, (_, data) => {
  return data
})

const $subscriptionPrices = createStore<SubscriptionPriceType[] | null>(null).on(
  getSubscriptionPricesFx.doneData,
  (_, data) =>
    data.filter((subscription) => subscription.description === 'platinum' || subscription.description === 'plus')
)

export const $selectedSubscriptionOption = createStore<SubscriptionPaymentOptions>('platinum').on(
  changeSubscriptionPaymentOption,
  (_, data) => data
)
export { $subscriptionPrices }

export const $selectedSubscriptionPrice = createStore<number>(0)

sample({
  clock: [getSubscriptionPricesFx.doneData, changeSubscriptionPaymentOption],
  source: {
    prices: $subscriptionPrices,
    currentOption: $selectedSubscriptionOption,
  },
  fn: ({ prices, currentOption }) => {
    if (!prices) return 0
    if (currentOption === 'platinumDiscount') {
      return prices.find((sub) => sub.description === 'platinum')!.price_stars * 0.7 || 0
    }
    const subscription = prices.find((sub) => sub.description === currentOption)
    return subscription?.price_stars || 0
  },
  target: $selectedSubscriptionPrice,
})

export const $selectedCurrency = createStore<ShopCurrencies>('stars').on(changeShopCurrency, (_, data) => data)
